






























import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'
import LeftSidebar from './parts/LeftSidebar.vue'
import RightSidebar from './parts/RightSidebar.vue'
import SettingsSidebar from './parts/SettingsSidebar.vue'
import KnowledgeSidebar from './parts/KnowledgeSidebar.vue'
import PaidBadge from '@/components/PaidLabel/PaidBadge.vue'
import ToggleMenuButton from '@/components/ToggleMenuButton/ToggleMenuButton.vue'
import ActiveScriptNotification from '@/components/Scripts/ActiveScriptNotification.vue'
import WindowResizeListener from '@/abstract/WindowResizeListener'

interface Data {
  isOpenMobileMenu: boolean
}

interface Computed {
  companyIsPro: boolean
  isOpenSettings: boolean
  isOpenKnowledge: boolean
}

interface Methods {
  handleToggleMobileMenu: () => void
  handleCloseMobileMenu: () => void
}

export default mixins(WindowResizeListener).extend<Data, Methods, Computed, {}>(
  {
    components: {
      LeftSidebar,
      RightSidebar,
      SettingsSidebar,
      KnowledgeSidebar,
      PaidBadge,
      ToggleMenuButton,
      ActiveScriptNotification,
    },
    data: () => ({
      isOpenMobileMenu: false,
    }),
    computed: {
      ...mapGetters({
        companyIsPro: 'getCompanyIsPro',
      }),
      isOpenSettings(): boolean {
        return this.isMobile || this.isShowSettings
      },
      isOpenKnowledge(): boolean {
        const additionalCondition = this.isMobile ? this.isOpenMobileMenu : true
        return this.isShowKnowledge && additionalCondition
      },
    },
    methods: {
      handleToggleMobileMenu() {
        this.isOpenMobileMenu = !this.isOpenMobileMenu
      },
      handleCloseMobileMenu() {
        if (this.isMobile) {
          this.isOpenMobileMenu = false
        }
      },
    },
  },
)
